import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import { postRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import './ThankYouForReview.scss';

class ThankYouForReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emails: [],
      submitting: false,
      successMessage: '',
      errorMessage: '',
      existingUsersMessage: '',
      invalidEmail: false,
      tag: '',
    };

    this.submitEmails = this.submitEmails.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.onValidationReject = this.onValidationReject.bind(this);
  }

  onValidationReject(values) {
    if (values && values.length && values[0].trim() !== '') {
      this.setState({ invalidEmail: true });
    }
  }

  handleInputChange(emails) {
    this.setState({ emails, invalidEmail: false });
  }

  handleEmailChange(input) {
    if (input === ' ' || input === ';' || input === ',') {
      return;
    }

    this.setState({ tag: input });
  }

  submitEmails() {
    const { emails } = this.state;
    const {
      csrfToken, newReferralPath, location, referredUserType,
    } = this.props;

    if (!emails.length) {
      return;
    }
    this.setState({ submitting: true });

    postRequest(
      newReferralPath,
      { emails, referred_user_type: referredUserType },
      csrfToken,
    ).then(({ data: { valid, invalid, already_member: ignored } }) => {
      const errEmails = invalid.map((referral) => referral.email);

      let errorMsg = '';
      if (invalid.length) {
        errorMsg = `You've already shared a referral link with ${errEmails.join(', ')}.`;
      }

      let successMsg = '';
      if (valid.length) {
        const plural = valid.length !== 1 ? 's' : '';
        const list = valid.map((referral) => referral.email).join(', ');
        successMsg = `Email${plural} sent! Recipient${plural}: ${list}`;
      }

      let existingUsersMsg = '';
      if (ignored.length) {
        const ignoredEmails = ignored.map((referral) => referral.email).join(', ');
        existingUsersMsg = `These referrals are already Clora members: ${ignoredEmails}`;
      }

      this.setState({
        errorMessage: errorMsg,
        successMessage: successMsg,
        existingUsersMessage: existingUsersMsg,
        emails: errEmails,
        submitting: false,
      });

      analyticsTrack('Clicked on Send invite emails', { location, referred_user_type: referredUserType });
    }).catch(() => {
      this.setState({
        errorMessage: 'Something has gone wrong. Please try again later',
        successMessage: '',
        submitting: false,
      });
    });
  }

  render() {
    const { userFirstName } = this.props;
    const {
      emails, successMessage, errorMessage, existingUsersMessage, invalidEmail, tag,
    } = this.state;
    const addKeys = [9, 13, 32, 186, 188]; // tab, enter, non-printing space, semi-colon, comma
    // From http://emailregex.com/

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return (
      <div className="thank-you-for-review style-guide">
        <h1 className="header mb-12">Thanks for your review!</h1>
        <p className="body-text-1">
          You can modify your review in the next 48 hours. Clora will
          publish your review on
          {userFirstName}
          &apos;s profile after that.
        </p>
        <hr />
        <h3 className="secondary mb-8">Help life science companies build better teams!</h3>
        <p className="body-text-2 mb-24">Invite fellow hiring managers to acquire talent faster!</p>

        <div className="form-inline flex">
          <TagsInput
            value={emails}
            onChange={this.handleInputChange}
            onChangeInput={this.handleEmailChange}
            className="form-control email-addresses fs-hide"
            addKeys={addKeys}
            inputProps={{
              placeholder: emails.length === 0 ? 'Enter email addresses...' : '',
              className: emails.length !== 0 && tag === '' ? 'react-tagsinput-input no-width' : ' react-tagsinput-input',
            }}
            inputValue={tag}
            addOnBlur
            validationRegex={emailRegex}
            onValidationReject={this.onValidationReject}
          />

          <button
            type="button"
            onClick={this.submitEmails}
            className={`employer-submit-emails btn btn-primary text-nowrap ${this.state.submitting ? 'disabled' : ''}`}
          >
            <span className="d-none d-md-block">Send </span>
            Invite
          </button>
        </div>

        {invalidEmail
          && <div className="text-danger  body-text-3 mt-5">Please enter a valid email address.</div>}
        {successMessage && <div className="text-primary body-text-3 mt-5">{successMessage}</div>}
        {errorMessage && <div className="text-danger body-text-3 mt-5">{errorMessage}</div>}
        {existingUsersMessage && <div className="body-text-3 mt-5">{existingUsersMessage}</div>}
      </div>
    );
  }
}

ThankYouForReview.propTypes = {
  userFirstName: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  newReferralPath: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  referredUserType: PropTypes.string.isRequired,
};

export default ThankYouForReview;
